import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { FileDown, ShieldCheck, ShieldOff } from "lucide-react";

const LABEL = { servizio: "Servizio", statistico: "Statistico", marketing: "Marketing" };
const fmt = (s) => (s ? new Date(s).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");

const RevocaDialog = ({ leadId, tipo, onClose, onDone }) => {
  const [data, setData] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/leads/${leadId}/privacy/revoca`, { tipo, data_ricezione: data, note });
      toast.success(`Consenso ${LABEL[tipo]} revocato`); onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="privacy-revoca-dialog">
        <DialogHeader><DialogTitle>Registra revoca consenso {LABEL[tipo]}</DialogTitle></DialogHeader>
        <label className="text-xs">Data ricezione PEC<Input type="date" value={data} onChange={(e) => setData(e.target.value)} data-testid="privacy-revoca-data" /></label>
        <label className="text-xs">Note<Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Es. protocollo PEC" data-testid="privacy-revoca-note" /></label>
        <DialogFooter><Button onClick={save} disabled={busy} data-testid="privacy-revoca-confirm">Registra revoca</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const PrivacyLeadPanel = ({ leadId, isAdmin }) => {
  const [d, setD] = useState(null);
  const [revoca, setRevoca] = useState(null);
  const load = useCallback(() => api.get(`/leads/${leadId}/privacy`).then((r) => setD(r.data)).catch(() => {}), [leadId]);
  useEffect(() => { load(); }, [load]);
  const p = d?.privacy;
  if (!d || !p) return null;
  const pdf = async () => {
    const w = window.open("", "_blank");
    try { const r = await api.get(`/leads/${leadId}/privacy/pdf`, { responseType: "blob" }); w.location.href = URL.createObjectURL(r.data); }
    catch (e) { w.close(); toast.error("Impossibile generare il PDF"); }
  };
  return (
    <div className="mt-5 pt-5 border-t border-border" data-testid="lead-privacy-card">
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs uppercase tracking-widest text-muted-foreground flex items-center gap-1.5"><ShieldCheck className="h-3 w-3 text-primary" /> Privacy</div>
        <Button size="sm" variant="outline" className="h-7 px-2" onClick={pdf} data-testid="privacy-pdf-btn"><FileDown className="h-3.5 w-3.5 mr-1" /> PDF</Button>
      </div>
      <div className="space-y-1.5">
        {Object.entries(p.consensi || {}).map(([k, c]) => (
          <div key={k} className="flex items-center justify-between text-xs" data-testid={`privacy-consenso-${k}`}>
            <span><b>{LABEL[k]}</b> · {c.revocato_at ? <span className="text-destructive">revocato {fmt(c.revocato_at)}</span> : <span className="text-emerald-700">accettato {fmt(c.at)}</span>}</span>
            {isAdmin && !c.revocato_at && <Button size="sm" variant="ghost" className="h-6 px-1.5 text-[11px]" onClick={() => setRevoca(k)} data-testid={`privacy-revoca-${k}`}><ShieldOff className="h-3 w-3 mr-1" /> Revoca</Button>}
          </div>
        ))}
      </div>
      <p className="mt-2 text-[10px] text-muted-foreground">Informativa {p.versione} · {p.pagina === "configuratore_self_service" ? "configuratore self-service" : p.pagina} · IP {p.ip}</p>
      {revoca && <RevocaDialog leadId={leadId} tipo={revoca} onClose={() => setRevoca(null)} onDone={() => { setRevoca(null); load(); }} />}
    </div>
  );
};
